export interface ButtonProps {
    text?: string;
    icon?: any;
    iconPosition?: ButtonIconPosition;
    iconColorType?: "fill" | "stroke";
    type?: ButtonType;
    buttonType?: "button" | "submit";
    disable?: boolean;
    onClick?(e?: any): void | Promise<any>;
    size?: ButtonSize;
    className?: string;
    autoFocus: boolean;
    textClassName?: string;
}

export enum ButtonIconPosition {
    LEFT,
    RIGHT
}

export enum ButtonType {
    PRIMARY,
    SECONDARY,
    TERTIARY,
    TEXT,
    DELETE,
    CANCEL
}

export enum ButtonSize {
    LG,
    MD,
    SM
}
